import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";
import { authRoutes, publicRoutes } from "./router.link.lazy";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import { RouteLoadingFallback } from "./RouteLoadingFallback";

// Lazy load Login component
const Login = React.lazy(() => import("../auth/login/login"));

const ALLRoutes: React.FC = () => {
  return (
    <Suspense fallback={<RouteLoadingFallback variant="fullscreen" />}>
      <Routes>
        <Route path="/" element={<Suspense fallback={<RouteLoadingFallback variant="fullscreen" />}><Login /></Suspense>} />
        <Route element={<Feature />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default ALLRoutes;
